(function () {
  let stickyObserved = null;

  function applyOffset() {
    const bubble = document.getElementById('chat-bubble');
    const sticky = document.querySelector('.sticky-atc');
    if (!bubble) return;

    if (sticky && getComputedStyle(sticky).display !== 'none') {
      const height = sticky.getBoundingClientRect().height;
      if (height > 0) {
        bubble.style.setProperty('bottom', (height + 16) + 'px', 'important');
      }
      if (sticky !== stickyObserved && window.ResizeObserver) {
        stickyObserved = sticky;
        new ResizeObserver(applyOffset).observe(sticky);
      }
      return;
    }
    bubble.style.removeProperty('bottom');
  }

  function watch() {
    applyOffset();
    window.addEventListener('resize', applyOffset);
    window.addEventListener('load', applyOffset);

    const observer = new MutationObserver(applyOffset);
    observer.observe(document.body, { childList: true, subtree: true });

    let attempts = 0;
    const poll = setInterval(function () {
      applyOffset();
      attempts += 1;
      if (attempts >= 20) clearInterval(poll);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
